import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

import { getRequirementDefinitionTableCellProps } from "../../../../../RequirementDefinitions/utils";
import {
  CellsConfig,
  ContextItem,
  RequirementTableCallback
} from "../../../../types";
import { getRequirementEngagementsTableCellProps } from "../../../../utils";
import { getPayoutMethodRequirementName } from "../helpers/getPayoutMethodRequirementName";
import { getPayoutMethodRequirementPayeeStatusCell } from "../helpers/getPayoutMethodRequirementPayeeStatusCell";

export const usePayeePayoutMethodConfig = (
  _callback: RequirementTableCallback
): CellsConfig<PayeeRequirement, ContextItem, undefined> => {
  return {
    isActionRequired: () => false,

    requirementName: getPayoutMethodRequirementName,

    toolbarActions: (requirement, context, additionalData) => {
      return [];
    },

    nameCell: requirement => ({
      text: getPayoutMethodRequirementName(requirement)
    }),

    typeCell: requirement =>
      getRequirementDefinitionTableCellProps({
        type: requirement.type!
      }),

    statusCell: getPayoutMethodRequirementPayeeStatusCell,

    engagementsCell: getRequirementEngagementsTableCellProps
  };
};
